import Vue from "vue";
import VueMeta from "vue-meta";
import VueCookieBot from '@ambitiondev/vue-cookiebot-plugin'
import VueGtag from "vue-gtag";
import LoadScript from 'vue-plugin-load-script';

// Setups go first
import "@/setup/api-setup";
import "@/setup/components-setup";
import "@/setup/filters-setup";
import "@/setup/plugins-setup";
import "@/setup/styles-setup";
import "@/setup/native-setup";

Vue.config.productionTip = false;
Vue.use(VueMeta);
Vue.use(VueCookieBot, {
  cookieBotID: process.env.VUE_APP_COOKIEBOT_ID
})
Vue.use(LoadScript);

import App from "@/App.vue";
import router from "@/router";
import store from "@/store";
import i18n from "@/i18n";

Vue.use(VueGtag, {
  bootstrap: false
}, router);

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
